<template>
<div class="sort">
    <button type="button" title="정렬보기" @click="selectBox" :name="[valName]" :value="[selectedVal]"></button>
    <div class="dim" v-show='selectBoxView'>
        <div class="botWrap selectSlide">
            <h6>{{ selectName }}</h6>
            <ul>
                <li v-for="(option, index) of options" @click="selected = option.text;$emit('input', option);selectedVal = option.value;$emit('input', option);sortCrt(option)" :key="index">
                    <button type="button" :class="{'current' : option == current}">{{ option.text }}</button>
                </li>
            </ul>
            <button type="button" class="close" @click="selectBox">닫기</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'sortBtn',
    props: {
        selectName: String,
        options: {
            type: Array,
            required: true,            
        },
        valName: {
            type: String,
            default: null,
        },
        default: {
            type: Number,
            default: null,
        }
    },
    data() {        
      return {
        selectBoxView : false,
        selected:
            this.default ? this.options[this.default].text : 
            this.options.length > 0 ? this.options[0].text : null,
        selectedVal:
            this.default ? this.options[this.default].value : 
            this.options.length > 0 ? this.options[0].value : null,
        current:
            this.default ? this.options[this.default] : 
            this.options.length > 0 ? this.options[0] : undefined,
      };
    },
    mounted() {
        this.$emit("input", this.selected); 
        this.$emit("input", this.selectedVal);    
    },
    methods: {
        selectBox: function(){
            this.selectBoxView = !this.selectBoxView;
        },
        sortCrt: function(index) {                
            if(this.current==index) this.current=null;
            else this.current=index;
            let sortVal = index.value;
            this.$emit('sortVal', sortVal);
            this.selectBoxView = !this.selectBoxView;
        }
    },
};
</script>